import WidgetBase from '../widget.base';
import Carousel from '../../services/carousel';
import AccordionComponent from '../../components/accordion';
import { each, mq } from '../../lib/util';

export default class AttractionDetails extends WidgetBase {
    static selector = '[data-ww-attraction-details]';

    constructor(el){
        super(el);
        this.initialize();
    }

    initialize() {
        // Get all the carousels
        this.carousels = this.el.querySelectorAll('[data-js-media-gallery]');
        // Start all carousels
        this.startCarousels();
        // Only display accordions on mobile
        if (!mq('sm')) {
            // Get all accordions
            this.accordions = this.el.querySelectorAll('[data-attraction-accordion]');
            // Start all accordions
            this.startAccordions();
        }
    }

    /**
     * Start all carousels
     */
    startCarousels() {
        // Loop through all the Apply Selected buttons
        each(this.carousels, (carousel) => {
            new Carousel(carousel);
        });
    }

    /**
     * Start all accordions
     */
    startAccordions() {
        // Loop through all the accordions
        each(this.accordions, (accordion) => {
            new AccordionComponent(accordion);
        });
    }
}